import { render } from "./Header.vue?vue&type=template&id=e3648890&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "@/assets/scss/_header.scss?vue&type=style&index=0&id=e3648890&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3648890"]])

export default __exports__